/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

import axios from "axios";
import { pathConstants } from "@/shared/pathConstants";
import Vue from "vue";
import eventBus from "@/shared/event.bus";

const IMPORT_API = "/import";
const IMPORT_PREVIEW_API = pathConstants.API + IMPORT_API + "/importPreview";
const PERSIST_IMPORT_API = pathConstants.API + IMPORT_API + "/persistImport";

const getMappingsNamesByFiche = function(
  isPersonnePhysique,
  isPersonneMorale,
  ficheId
) {
  return axios
    .get(
      pathConstants.API +
        IMPORT_API +
        `/with-mapping?isPersonnePhysique=${isPersonnePhysique}&isPersonneMorale=${isPersonneMorale}&ficheId=${ficheId}`
    )
    .then(
      result => {
        return result.data;
      },
      err => {
        Vue.$log.error("getFichesWithMapping", err);
      }
    );
};

const getDownloadMappingFile = function(mappingId, mappingName = "") {
  const params = {
    mappingId,
    mappingName
  };
  return axios
    .get(pathConstants.API + IMPORT_API + `/download-mapping-file`, {
      params: params,
      responseType: "blob"
    })
    .then(
      result => {
        return result;
      },
      err => {
        Vue.$log.error("downloadMappingFile", err);
      }
    );
};

const getPreviewOperationsInMassAction = function(massImport, file) {
  const formData = new FormData();
  formData.append(
    "file",
    file,
    "file_mapping." + file.name.split(".").pop() || ""
  );
  const dtoAsText = new Blob([JSON.stringify(massImport)], {
    type: "application/json"
  });
  formData.append("dto", dtoAsText);

  return axios.post(IMPORT_PREVIEW_API, formData).then(
    result => {
      return result.data;
    },
    err => {
      Vue.$log.error("getPreviewOperationsInMassAction", err);
      throw err;
    }
  );
};

const persistImport = function(massImport, file) {
  const formData = new FormData();
  formData.append("file", file, file.name || "");
  const dtoAsText = new Blob([JSON.stringify(massImport)], {
    type: "application/json"
  });
  formData.append("dto", dtoAsText);

  return axios.post(PERSIST_IMPORT_API, formData).then(
    result => {
      Vue.prototype.$notification.success(
        "L'import sera traîté en arrière-plan"
      );
      eventBus.$emit("start-import", {
        clientReferenceId: massImport?.upload?.clientRefId,
        importId: result.data.id
      });
      return result.data;
    },
    err => {
      Vue.$log.error("persistImport", err);
      throw err;
    }
  );
};

const fetchImportProgress = function(importId) {
  return axios
    .get(pathConstants.API + IMPORT_API + `/fetch-import-by-id/${importId}`)
    .then(
      result => {
        return result.data;
      },
      err => {
        Vue.$log.error("fetchImportProgress", err);
      }
    );
};

const getImportInMassDetailBySimulationId = function(simulationId) {
  return axios
    .get(
      pathConstants.API +
        IMPORT_API +
        `/fetch-import-by-simulation-id/${simulationId}`
    )
    .then(
      result => {
        return result.data;
      },
      err => {
        Vue.$log.error("getImportInMassDetailBySimulationId", err);
      }
    );
};

export const importService = {
  getMappingsNamesByFiche,
  getDownloadMappingFile,
  getPreviewOperationsInMassAction,
  persistImport,
  fetchImportProgress,
  getImportInMassDetailBySimulationId
};
